import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { faBars, faListDots, faEllipsisVertical, faWeight, faEnvelope, faArrowCircleRight, faArrowCircleLeft, faEnvelopesBulk, faUsers, faAngleDown, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { AuthService } from '../auth/auth.service';
import { StorageKeys } from '../../share/enums/storage.enum';
// @ts-ignore
import { Tooltip } from 'bootstrap/dist/js/bootstrap.esm.js';
import { Router, NavigationEnd, Event } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit, AfterViewInit {
  enrollmentType: any;
  activeItem: string = '';
  activeSubItem: string = '';
  constructor(
    private readonly storageService: StorageService,
    public readonly authService: AuthService,
    private readonly router: Router,
  ) {
    this.router.events.pipe(
      filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.setActiveItemByRoute(event.urlAfterRedirects);
    });
  }
  @Input() isExpanded: boolean = false;
  @Output() toggleSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChildren('collapse') collapses!: QueryList<ElementRef>;
  isSubMenuActive: boolean = false;
  selectedMenuItem: number = 1;
  user: any = {};
  nextLevel: any;
  userName: string | undefined;
  userDetailsData: any;
  profilePic: any;
  bootstrap: any;
  open: any = {};
  isAdmin: boolean = false;

  ngOnInit() {
    this.getSelfDetails();
    Array.from(
      document.querySelectorAll('button[data-bs-toggle="tooltip"]')
    ).forEach((tooltipNode) => new Tooltip(tooltipNode));
  }
  
  isMenuItemActive(index: number): boolean {
    return this.selectedMenuItem === index;
  }

  setSelectedMenuItem(index: number): void {
    this.selectedMenuItem = index;
  }

  getSelfDetails() {
    this.authService.getSelfDetails().subscribe((res) => {      
      this.storageService.setDataToLocalStorage(
        StorageKeys.SELF_DETAILS,
        res.data
      );
      this.userDetailsData = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);      
      this.profilePic = this.userDetailsData?.profileImage;
      if (this.userDetailsData.enrollmentType === 'Admin') {
        this.isAdmin = true;
      }
    });
  }

  redirectToHome() {
    if (!this.isAdmin) {
      this.router.navigate(['/home']).then(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

  setActiveItemByRoute(url: string): void {
    if (url === '/' || url === '/home') {
      this.activeItem = 'stockSummary';
      this.collapseAllMenus();
      this.open.stock = true;
      return;
    }

    this.open.stock = url.includes('view-import-stock-list');

    const routeMappings = [
      { keys: ['view-import-stock-list'], item: 'stockSummary' },
      { keys: ['product-list', 'new-product'], item: 'product-list' },
      { keys: ['new-dealer', 'dealer-list'], item: 'dealer-list' },
      { keys: ['order-out'], item: 'order-out' },
      { keys: ['sale-to-dealer'], item: 'sale-to-dealer' },
      { keys: ['transfer-to-branch'], item: 'transfer-to-branch' },
      { keys: ['order-list'], item: 'order-list' },
      { keys: ['return-to-dealer'], item: 'return-to-dealer' },
      { keys: ['return-from-customer'], item: 'return-from-customer' },
      { keys: ['return-and-replace'], item: 'return-and-replace' },
      { keys: ['service-entry'], item: 'service-entry' },
      { keys: ['service-list'], item: 'service-list' },
      { keys: ['master-data-list', 'add-master-data'], item: 'tyre-size', extra: () => { this.selectedMenuItem = -1; } },
      { keys: ['master-data'], item: 'master-data' },
      { keys: ['inventory'], item: 'inventory' },
      { keys: ['admin/sub-company-users'], item: 'admin/sub-company-users' },
      { keys: ['admin/company', 'admin/view-company'], item: 'branch-list' },
      { keys: ['admin/users'], item: 'admin/users' },
      { keys: ['admin/sdex/company', 'admin/sdex-view-company'], item: 'admin/sdex/company' },
      { keys: ['tyre-model-list'], item: 'tyre-model-list' },
      { keys: ['pending-tyre-pattern'], item: 'pending-tyre-pattern' },
      { keys: ['tyre-brand-list'], item: 'tyre-brand-list' },
      { keys: ['vehicle-model-list'], item: 'vehicle-model-list' },
      { keys: ['vehicle-make-list'], item: 'vehicle-make-list' },
      { keys: ['day-book'], item: 'day-book', noScroll: true },
      { keys: ['sku-ledger'], item: 'sku-ledger', noScroll: true },
      { keys: ['sku-merge'], item: 'sku-merge', noScroll: true },
      { keys: ['payments-account'], item: 'payments-account', noScroll: true },
      { keys: ['balance-account', 'balance-transfers'], item: 'balance-account', noScroll: true },
      { keys: ['settlements'], item: 'settlements', noScroll: true },
      { keys: ['expenses'], item: 'expenses', noScroll: true },
      { keys: ['expense-categories'], item: 'expense-categories', noScroll: true },
    ];

    const match = routeMappings.find(mapping => mapping.keys.some(key => url.includes(key)));
    if (match) {
      this.activeItem = match.item;
      if (!match.noScroll) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      if (match.extra) {
        match.extra();
      }
    }

    if (url.includes('balance-account') || url.includes('balance-transfers')) {
      this.open['accounts'] = true;
      setTimeout(() => {
        const target = this.getCollapse('accounts');
        target?.nativeElement.classList.add('show');
      });
    }
  }

  ngAfterViewInit() {
    this.setActiveItemByRoute(this.router.url);
    if (this.authService.isAdmin()) {
      this.openAdministrationByDefault();
    }
  }

  toggleMenu(menu: string) {
    const target = this.getCollapse(menu);
    if (!target) return;
    if (this.open[menu]) {
      this.open[menu] = false;
      target.nativeElement.classList.remove('show');
      return;
    }
    this.collapses.forEach(c =>
      c.nativeElement.classList.remove('show')
    );
    Object.keys(this.open).forEach(key => this.open[key] = false);
    this.open[menu] = true;
    target.nativeElement.classList.add('show');
  }

  private getCollapse(menu: string): ElementRef | undefined {
    return this.collapses.find(
      el => el.nativeElement.dataset.menu === menu
    );
  }

  openAdministrationByDefault() {
    this.open['admin'] = true;
    const target = this.getCollapse('admin');
    target?.nativeElement.classList.add('show');
  }

  collapseAllMenus() {
  if (!this.collapses?.length) {
  return;
  }
  this.collapses.forEach(c =>
    c.nativeElement.classList.remove('show')
  );
  Object.keys(this.open).forEach(key => {
    this.open[key] = false;
  });
  }

  protected readonly faListDots = faListDots;
  protected readonly faEllipsisVertical = faEllipsisVertical;
  protected readonly faWeight = faWeight;
  protected readonly faEnvelope = faEnvelope;
  protected readonly faArrowCircleRight = faArrowCircleRight;
  protected readonly faArrowCircleLeft = faArrowCircleLeft;
  protected readonly faEnvelopesBulk = faEnvelopesBulk;
  protected readonly faUsers = faUsers;
  protected readonly faAngleDown = faAngleDown;
  protected readonly faAngleRight = faAngleRight;
  protected readonly faBars = faBars;
}
